import { render, staticRenderFns } from "./Discapacidad.vue?vue&type=template&id=01b3b158&scoped=true"
import script from "./Discapacidad.vue?vue&type=script&lang=js"
export * from "./Discapacidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b3b158",
  null
  
)

export default component.exports